import React, { useMemo, useState } from 'react';
import challengesData from '../data/challenges.json';
import { useTheme } from '../context/ThemeContext';
import Modal from './Modal';

function Challenges() {
  const { isDark } = useTheme();
  const [selectedChallenge, setSelectedChallenge] = useState(null);

  const sortedChallenges = useMemo(() => {
    return challengesData.challenges.sort((a, b) => b.score - a.score);
  }, []);

  return (
    <div id="challenges">
      <h1 className={`text-3xl font-bold mb-4 text-center ${isDark ? 'text-hack-accent' : 'text-cyan-600'}`}>Challenges</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {sortedChallenges.map((challenge) => (
          <div
            key={challenge.name}
            onClick={() => setSelectedChallenge(challenge)}
            className={`rounded-lg p-6 transition-all duration-200 cursor-pointer h-full ${isDark 
              ? 'bg-hack-primary shadow-md hover:bg-hack-accent/10 border border-gray-700' 
              : 'bg-gray-50 hover:bg-white border border-gray-200'}`}
          >
            <div className="flex items-center justify-between mb-4">
              <span className={`font-mono text-sm ${isDark ? 'text-hack-accent' : 'text-cyan-600'}`}>{challenge.category}</span>

            </div>
            <h3 className={`text-xl font-bold mb-4 ${isDark ? 'text-gray-100' : 'text-gray-800'}`}>{challenge.name}</h3>
            <div className={`flex items-center justify-between text-sm ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
              <span>Level: {challenge.level}</span>
              <span>{challenge.score} points</span>
            </div>
          </div>
        ))}
      </div>

      <Modal
        isOpen={!!selectedChallenge}
        onClose={() => setSelectedChallenge(null)}
      >
        {selectedChallenge && (
          <div>
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className={`text-2xl font-bold mb-2 ${isDark ? 'text-gray-100' : 'text-gray-800'}`}>{selectedChallenge.name}</h2>
                <div className="flex items-center space-x-4 text-sm">
                  <span className={isDark ? 'text-hack-accent' : 'text-cyan-600'}>{selectedChallenge.category}</span>
                  <span className={isDark ? 'text-gray-400' : 'text-gray-700'}>Level: {selectedChallenge.level}</span>
                  <span className={`font-semibold ${isDark ? 'text-hack-accent' : 'text-cyan-600'}`}>{selectedChallenge.score} pts</span>
                </div>
              </div>
            </div>

            <div className={`prose max-w-none mb-8 ${isDark ? 'prose-invert' : ''}`}>
              <p className={`leading-relaxed ${isDark ? 'text-gray-200' : 'text-gray-700'}`}>{selectedChallenge.description}</p>
            </div>

            <div className="flex justify-end">
              <button
                onClick={() => setSelectedChallenge(null)}
                className={`px-4 py-2 transition-colors ${isDark 
                  ? 'text-gray-400 hover:text-gray-300' 
                  : 'text-gray-600 hover:text-gray-900'}`}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

export default Challenges;
